import { render, staticRenderFns } from "./WithoutLinkNick.vue?vue&type=template&id=48e582a1&scoped=true"
import script from "./WithoutLinkNick.vue?vue&type=script&lang=js"
export * from "./WithoutLinkNick.vue?vue&type=script&lang=js"
import style0 from "./WithoutLinkNick.vue?vue&type=style&index=0&id=48e582a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e582a1",
  null
  
)

export default component.exports